import { getAxiosClient } from "../../axios-client";
import { ClientAddBody, ClientAddResponse } from "./types";


const axiosClient = getAxiosClient();
export const ClientAdd = async (
  body: ClientAddBody
) => {
  return await axiosClient.ax.post<ClientAddResponse>(
    "/Clients/ClientsAdd",
    body
  );
};
